module.exports = __webpack_public_path__ + "static/scheiben-tablet-2957072980f82c1535d1bc272a274b67.jpg";